/*eslint complexity: off*/
import React from 'react';
import moment from 'moment';

import FaceIcon from '@material-ui/icons/Face';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';

import InputLabel from '@material-ui/core/InputLabel';
import Chip from '@material-ui/core/Chip';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import InputShow from '~/components/InputShow';

export function SusServiceShowForm({ atendimento }) {
  const a = atendimento || {};
  const dataFmt = a.data
    ? moment(a.data, 'YYYY-MM-DDTHH:mm:ss').format('D [de] MMMM [de] YYYY [às] HH:mm')
    : '-';

  return (
    <Card style={{ marginBottom: 15, padding: 10 }}>
      <CardContent>
        <GridContainer spacing={4}>
          <GridItem xs={12} sm={6} md={6}>
            <InputShow label={'Data'} value={dataFmt} />
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <InputShow label={'Local da consulta'} value={a.unidade || '-'} />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={6} md={6}>
            <InputLabel shrink style={{ marginBottom: 10 }}>
              {'Profissional'}
            </InputLabel>
            <Chip
              style={{ marginRight: 5 }}
              icon={<FaceIcon />}
              label={a.profissional || '-'}
              variant="outlined"
              color="primary"
            />
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <InputLabel shrink style={{ marginBottom: 10 }}>
              {'Especialidade'}
            </InputLabel>
            <Chip
              icon={<LocalHospitalIcon />}
              label={a.especialidade || '-'}
              variant="outlined"
            />
          </GridItem>
        </GridContainer>
      </CardContent>
    </Card>
  );
}
